require('./fieldRuleAction.i18n.json');
require('./fieldRuleAction.tpl.html');
require('./fieldRuleActionController.js');

const FieldRuleActionComponent = {
    templateUrl: '/configuration/formEditor/content/rule/fieldRuleBuilder/fieldRuleAction.tpl.html',
    controller: 'fieldRuleActionController',
    bindings: {
        fieldRule: '<',
        fieldsInRule: '<',
        canUserManageFormRules: '<',
        onFieldsInRuleUpdated: '&'
    }
};

angular.module('ums')
    .component('uiFieldRuleAction', FieldRuleActionComponent);
